import { useEffect, useState } from "react";
import { Input } from "antd";
import { ContentApi } from "../api/contentApi";
import ValueInput from "./ValueInput";
import { parseOptionsJson } from "./parseOptionsJson";

/**
 * Подставляет контрол редактирования значения параметра по его valueTypeCode.
 * Принимает уже загруженный `parameter` (с полем `optionsJson`), либо, если параметр
 * не передан, догружает его через GET .../parameters/{parameterId}.
 */
export default function ParamValueField({ projectId, versionId, parameter, parameterId, value, onChange, disabled }) {
    const [resolvedParameter, setResolvedParameter] = useState(parameter || null);

    useEffect(() => {
        setResolvedParameter(parameter || null);
    }, [parameter]);

    useEffect(() => {
        const id = parameter?.id || parameter?.parameterId || parameterId;
        if (parameter || !id || !projectId || !versionId) return;

        const ac = new AbortController();
        ContentApi.getParameterById(projectId, versionId, id, { signal: ac.signal })
            .then((full) => {
                if (!ac.signal.aborted) setResolvedParameter(full);
            })
            .catch(() => {});
        return () => ac.abort();
    }, [parameter, parameterId, projectId, versionId]);

    if (!resolvedParameter) {
        return <Input className="" disabled placeholder="Выберите параметр" />;
    }

    const valueType = resolvedParameter.valueTypeCode || resolvedParameter.valueType;
    const options = parseOptionsJson(resolvedParameter.optionsJson ?? resolvedParameter.options);
    return (
        <ValueInput
            valueType={valueType}
            options={options}
            value={value}
            onChange={onChange}
            disabled={disabled}
        />
    );
}
